/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Logo-squares': {
    width: 25,
    height: 26,
    viewBox: '0 0 25 26',
    data: '<path pid="0" d="M8.296 17.404a.5.5 0 00-.5-.5H.5a.5.5 0 00-.5.5v7.285a.5.5 0 00.5.5h7.296a.5.5 0 00.5-.5v-7.285zm0-16.417a.5.5 0 00-.5-.5H.5a.5.5 0 00-.5.5v7.285a.5.5 0 00.5.5h7.296a.5.5 0 00.5-.5V.987zm16.406 16.417a.5.5 0 00-.5-.5h-7.296a.5.5 0 00-.5.5v7.285a.5.5 0 00.5.5h7.296a.5.5 0 00.5-.5v-7.285zm0-16.417a.5.5 0 00-.5-.5h-7.296a.5.5 0 00-.5.5v7.285a.5.5 0 00.5.5h7.296a.5.5 0 00.5-.5V.987z" _fill="#9BC225"/>'
  }
})
